import {NavLink} from "react-router-dom";
import {AppPages, usePageUrl} from "../../app-layout/AppPages";
import {Typography} from "@mui/material";
import React from "react";


export function TooltipKeyLink({keyNumber}: {
    keyNumber: string,
}) {
    const pageUrl = usePageUrl();

    return (
        <NavLink
            to={pageUrl(AppPages.keys, {}, {'search': keyNumber.toString()})}
            style={{borderColor: 'white', textDecorationColor: 'white', minWidth: '40px'}}
        >
            <Typography sx={{color: 'white'}}>{keyNumber}</Typography>
        </NavLink>
    );
}
